export default __webpack_public_path__ + "static/media/0d12f96709ce71ff.1ddd11a02cc0d36fac85fbbd929d6170.svg";